import React, { useState } from "react";
import { Text, View } from "react-native";
import { connect } from "react-redux";
import { setUserLoginData } from "../actions/user";
import { fetchToken } from "../api";
import { encodeString } from "../api/security";
import { STYLES } from "../assets/styles";
import Logo from "../common/Logo";
import CustomButton from "./CustomButton";
import CustomInput from "./CustomInput";

function SignIN({
  loginUser,
  onForgotPress = () => {},
  onCreateAccountPress = () => {},
  onLoadingChange = () => {},
  containerStyle = {},
  color = STYLES.colors.white,
  transparent,
}) {
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [required, setRequired] = useState(false);

  const handleLogin = () => {
    if (username && password) {
      onLoadingChange(true);
      fetchToken({ username, password }).then((res) => {
        onLoadingChange(false);
        if (!res.error) {
          let currentTime = parseInt(new Date().getTime() / 1000);
          res["expiry_time"] = currentTime + res.expires_in;
          res["access_token"] = encodeString(res.access_token);
          loginUser(res);
        } else {
          setError(res.error_description);
        }
      });
    } else {
      setRequired(true);
    }
  };

  return (
    <View
      style={[
        transparent ? {} : STYLES.shadow,
        {
          width: "90%",
          padding: 20,
        },
        containerStyle,
      ]}
    >
      <Logo color={color} />
      <Text
        style={{
          color: color,
          fontSize: STYLES.fontSizes.xlarge,
          marginVertical: 15,
        }}
      >
        {"Sign In"}
      </Text>
      <CustomInput
        leftIcon={{
          type: "MaterialCommunityIcons",
          name: "email-newsletter",
        }}
        iconStyle={{ color: color }}
        transparent={transparent}
        value={username}
        onChangeText={(value) => {
          setUserName(value);
          setError("");
        }}
        color={color}
        required={true}
        error={required && !username}
        requiredText="username or email"
        style={{ marginVertical: 10 }}
        placeholder="Username"
      />
      <CustomInput
        leftIcon={{ type: "MaterialIcons", name: "lock" }}
        rightIcon={{
          type: "Ionicons",
          name: showPassword ? "md-eye" : "md-eye-off",
          onPress: () => setShowPassword(!showPassword),
        }}
        iconStyle={{ color: color }}
        transparent={transparent}
        secureTextEntry={!showPassword}
        value={password}
        onChangeText={(value) => {
          setPassword(value);
          setError("");
        }}
        color={color}
        requiredText="your password"
        required={true}
        error={required && !password}
        style={{ marginVertical: 10 }}
        placeholder="Password"
      />
      {error ? (
        <Text style={{ color: STYLES.colors.tomato, textAlign: "center" }}>
          {error}
        </Text>
      ) : null}
      <CustomButton
        text="Forgot Password ?"
        onPress={onForgotPress}
        btnStyle={{ marginVertical: 10 }}
        textStyle={{
          color: color,
          fontSize: STYLES.fontSizes.small,
        }}
        transparent
      />
      <CustomButton
        text="Sign In"
        btnStyle={{
          marginVertical: 10,
          backgroundColor: transparent ? "#ffffff" : "#000000",
        }}
        onPress={handleLogin}
        textStyle={{ color: transparent ? "#000000" : "#ffffff" }}
      />
      <CustomButton
        onPress={onCreateAccountPress}
        text="Don't Have a account? Create Account"
        transparent
        btnStyle={{
          marginVertical: 10,
        }}
        textStyle={{
          color: color,
          fontSize: STYLES.fontSizes.small,
        }}
      />
    </View>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  loginUser: (data) => dispatch(setUserLoginData(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIN);
